import { ApiClient } from './client.js'
import { LICENSING_INVOICES } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (invoiceId) {
    return client.get(`${LICENSING_INVOICES}${invoiceId}/`)
  },

  pdf (invoiceId) {
    return client.get(`${LICENSING_INVOICES}${invoiceId}/pdf/`, {
      responseType: 'arraybuffer'
    })
  },

  list () {
    return client.get(`${LICENSING_INVOICES}`)
  },

  listAll () {
    return client.getAll(`${LICENSING_INVOICES}`)
  }
}
